import React, { Component } from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_PEDIDO_CAMIONES_EN_PLAYA } from '../../../../../../config/tables'

export class TablaPedidoCamionesEnPlayaView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_PEDIDO_CAMIONES_EN_PLAYA} />
    )
  }
}
